import { call, put, takeLatest } from 'redux-saga/effects';
import apiRequests from 'config/services';              // make sure this exports getSingleEntityMatch
import { setMatcherSingleCustomInput } from 'store/slices/matcherSingleCustomInputSlice';
import { sagaGetSingleEntityMatchAction } from 'saga/actions/matcher';
import { iSingleEntityMatchResponse } from 'store/types/matcher';
import { matcherConstants } from 'saga/actions/matcher';

export function* getSingleEntityMatchSaga(action: ReturnType<typeof sagaGetSingleEntityMatchAction>) {
  try {
    const { customInput, validation } = action.payload;
    // call your API helper
    const response: iSingleEntityMatchResponse = yield call(
      apiRequests.getSingleEntityMatch,
      customInput,
      validation
    );
    yield put(setMatcherSingleCustomInput(response));
  } catch (e) {
    console.error('matcher saga error', e);
  }
}

export function* matcherSagaHook() {
  yield takeLatest(matcherConstants.SAGA_GET_SINGLE_ENTITY_MATCH, getSingleEntityMatchSaga);
}
